import styled from "@emotion/styled";
import theme from "@theme";

const CardContainerStyle = styled.div`
  margin: auto;
  border: 1px solid ${theme.colors.bordertask};
  border-radius: 8px;
  max-width: 100%;
  overflow: hidden;
`;

const MessageContent = styled.div`
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  overflow-wrap: anywhere;
  word-break: break-word;

  img,
  video,
  iframe {
    max-width: 100%;
    height: auto;
  }

  table {
    max-width: 100%;
  }
`;

const Label = styled.div`
  display: flex;
  text-align: left;
  flex: 0.2;
  font-family: "Charlie Sans", sans-serif;
  font-size: 13px;
  font-weight: bold;
`;

const Astrik = styled.span`
  color: red;
`;

const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 2px 1px 2px 15px;
`;

const Children = styled.div`
  flex: 2;
`;

const Wrapper = styled.div`
  display: flex;
  padding: 0px;
`;

const SC = {
  CardContainerStyle,
  MessageContent,
  Label,
  Astrik,
  LabelContainer,
  Children,
  Wrapper,
};

export default SC;
